import React from 'react';
import usePromediosResultados from '../hooks/adminexamen/usePromediosResultados';

import { Button, Card, List, Select, Typography } from "antd";
import { Toaster } from 'react-hot-toast';

const { Link } = Typography;

const PromediosResultados = () => {

    const { loading, carreras, reporteGeneralPromediosPorMateria, reportePromedioResultadosPorCarrera, reporteTodosPromediosResultadosPorCarrera,
        ciclo, ciclosExamen, setCiclo  } = usePromediosResultados();

    return (
        <Card>
            <Toaster/>


            <p>Filtrar por año:</p>
            <Select
                size="large"
                style={{
                    width: 200,
                    marginBottom: 20
                }}
                onChange={ setCiclo }
                defaultValue={ ciclo }
            >
                { ciclosExamen.map((e, i) =>{
                    return (
                        <Select.Option key={ i } value={ e.ciclo_examen }>
                            { e.ciclo_examen }
                        </Select.Option>
                    )}) }
            </Select>

            <List
                loading={loading}
                size="large"
                header={
                    <div className='ta-center'><b>Promedios de resultados por carrera</b></div>
                }
                // bordered
                dataSource={carreras}
                renderItem={item => {
                    return (
                        <List.Item>
                            <Link className='link-carrera' target='_blank' onClick={() => reportePromedioResultadosPorCarrera(item.pk_carrera, item.nom_carrera)} >
                                {item.nom_carrera}
                            </Link>
                        </List.Item>
                    )
                }}
            />

            <br/>
            <br/>

            <Button type='primary' onClick={() => reporteTodosPromediosResultadosPorCarrera()} >Expediente de todos los promedios de resultados por carrera</Button>


            <br/>
            <br/>

            <Button type='primary' onClick={() => reporteGeneralPromediosPorMateria()} >Promedio general de resultados por materia</Button>


        </Card>
    );


}

export default PromediosResultados;
